/**
 * CollabPresenceStrip — peer-cursor pills shown above the mixer when a
 * collab session has live peers attached. Extracted from ELPMStudioDAW
 * during the iter-178 refactor pass.
 *
 * Props:
 *   peers              — array of { id, name, channel } from useYjsAwareness
 *   status             — collab.status ("connected" | "connecting" | "idle")
 *   peerColor(id)      — color resolver shared with the rest of the DAW
 *   onSelectChannel    — clicks a pill → focus that peer's channel
 */
export default function CollabPresenceStrip({ peers, status, peerColor, onSelectChannel }) {
  if (status !== "connected" || !peers || peers.length === 0) return null;
  return (
    <div
      data-testid="collab-presence-strip"
      className="mb-3 flex flex-wrap items-center gap-2 rounded-2xl border border-sky-400/30 bg-gradient-to-r from-sky-500/8 via-emerald-500/6 to-fuchsia-500/8 px-3 py-2 backdrop-blur"
    >
      <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/55">
        Live · cursors:
      </span>
      {peers.map((c) => (
        <button
          key={`cursor-${c.id}`}
          type="button"
          data-testid={`collab-cursor-${c.id}`}
          onClick={() => onSelectChannel?.(c.channel)}
          title={`Jump to ${c.name}'s channel (CH ${String(c.channel + 1).padStart(2, "0")})`}
          className="flex items-center gap-1.5 rounded-full border border-white/15 bg-black/40 px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-white transition hover:border-fuchsia-400/50 hover:bg-fuchsia-500/15"
        >
          <span
            className="grid h-4 w-4 place-items-center rounded-full text-[9px] font-bold text-white ring-1 ring-white/10"
            style={{ background: peerColor(c.id) }}
          >
            {c.name.slice(0, 1).toUpperCase()}
          </span>
          <span className="text-white/85">{c.name}</span>
          <span className="text-fuchsia-200">CH {String(c.channel + 1).padStart(2, "0")}</span>
        </button>
      ))}
    </div>
  );
}
